import baseAPI from '@/api/base';
import { ACTIVITY_LOG_URL } from '@/utils/urls';
import { AxiosResponse } from 'axios';

export interface GetActivityLogs {
  organizationId: string;
  /** One action (login, create…), or every action when left out. */
  action?: string | null;
  /** One brand's app (chabad_digital, screenkode), or every app when left out. */
  source?: string | null;
  page?: number;
  limit?: number;
}

class ActivityLog {
  static getActivityLogs = async (params: GetActivityLogs): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(ACTIVITY_LOG_URL, {
      params: { ...params, action: params.action || undefined, source: params.source || undefined },
    });
    return response;
  };
}

export default ActivityLog;
